import axios from '@/libs/api.request'

/**
 * 未读通知数量
 */
export const apiNotificationUnreadCount = data => {
  return axios.request({
    url: '/admin/notifications/unread-count',
    method: 'get',
    data,
    notError: true,
  })
}

/**
 * 未读通知列表
 * @param {Object} data 分页参数 page、per_page
 */
export const apiNotificationList = data => {
  return axios.request({
    url: '/admin/notifications',
    method: 'get',
    data: data || { page: 1, per_page: 20 },
  })
}

/**
 * 单条通知标记已读
 * @param {number|string} id 通知 ID
 */
export const apiNotificationRead = id => {
  return axios.request({
    url: `/admin/notifications/${id}/read`,
    method: 'post',
  })
}

/**
 * 批量标记已读
 * @param {Array<number|string>} ids 通知 ID 列表
 */
export const apiNotificationReadBatch = ids => {
  return axios.request({
    url: '/admin/notifications/read-batch',
    method: 'post',
    data: { ids },
  })
}

/**
 * 全部标记已读
 */
export const apiNotificationReadAll = () => {
  return axios.request({
    url: '/admin/notifications/read-all',
    method: 'post',
  })
}
